module.exports = (rating, returnNegPercentage) => {
  let ratingPercentage = 0;
  if (rating) {
    ratingPercentage = ((rating / 5) * 100).toFixed(2);
    if (returnNegPercentage) {
      return 100 - ratingPercentage;
    }
  }
  return ratingPercentage;
};
